"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6260],{

/***/ 6260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomePage_HowItWorksSection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
;// CONCATENATED MODULE: ./components/HomePage/HowItWorks.tsx




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: _defineProperty({
            textAlign: 'center'
        }, theme.breakpoints.down('sm'), {
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(2, 0)
        }),
        rootNoIcon: _defineProperty({}, theme.breakpoints.down('sm'), {
            display: 'block'
        }),
        title: _defineProperty({}, theme.breakpoints.up('sm'), {
            padding: theme.spacing(1.5, 0),
            minHeight: '50px',
            verticalAlign: 'middle'
        }),
        icon: _defineProperty({
            display: 'block',
            margin: '0 auto',
            width: 200,
            maxHeight: 200
        }, theme.breakpoints.down('sm'), {
            width: 100
        }),
        iconWrapper: _defineProperty({}, theme.breakpoints.down('sm'), {
            width: 100
        }),
        content: {},
        addPadding: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        desc: _defineProperty({}, theme.breakpoints.down('xs'), {
            fontSize: "calc(".concat(theme.typography.body1.fontSize, "px * 0.95)"),
            lineHeight: "calc(".concat(theme.typography.body1.lineHeight, " * 0.8)")
        }),
        isSlideOnMobileContainer: {
            flexDirection: 'column',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
        },
        isSlideOnMobileIcon: {},
        isSlideOnMobileContent: {
            textAlign: 'center'
        },
        isSlideOnMobileDesc: {}
    });
});
var HowItWorks = function(props) {
    var ref;
    var classes = useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var icon = props.icon, title = props.title, desc = props.desc, titleVariant = props.titleVariant, descVariant = props.descVariant, homePage = props.homePage;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var isSlideOnMobile = homePage === null || homePage === void 0 ? void 0 : (ref = homePage.data) === null || ref === void 0 ? void 0 : ref.display_slider_hiw_section_on_mobile;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('hiw', classes.root, !isMobile && classes.addPadding, !icon && classes.rootNoIcon, isMobile && isSlideOnMobile && classes.isSlideOnMobileContainer),
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)('hiw__icon', classes.iconWrapper),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: icon,
                    alt: "",
                    className: (0,clsx_m/* default */.Z)('hiw__img', classes.icon, isMobile && isSlideOnMobile && classes.isSlideOnMobileIcon)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)('hiw__content', classes.content, isMobile && classes.addPadding, isMobile && isSlideOnMobile && classes.isSlideOnMobileContent),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)('hiw__head', classes.title),
                        children: title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: titleVariant || 'h3',
                            component: 'p',
                            color: 'primary',
                            className: 'hiw__title',
                            children: title
                        })
                    }),
                    desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: descVariant || 'body1',
                        className: (0,clsx_m/* default */.Z)('hiw__desc', classes.desc, isMobile && isSlideOnMobile && classes.isSlideOnMobileDesc),
                        component: 'div',
                        children: desc
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var HomePage_HowItWorks = (HowItWorks);

// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./node_modules/react-glider/dist/index.js
var dist = __webpack_require__(76142);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
;// CONCATENATED MODULE: ./components/HomePage/SliderHowItWork.tsx






var SliderHowItWork = function(param) {
    var homePage = param.homePage, t = param.t;
    var ref, ref1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (homePage === null || homePage === void 0 ? void 0 : (ref = homePage.data) === null || ref === void 0 ? void 0 : ref.howitworks.length) > 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
            hasArrows: true,
            draggable: true,
            scrollLock: true,
            iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
            iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
            slidesToShow: 1,
            scrollLockDelay: 100,
            duration: 1,
            children: homePage === null || homePage === void 0 ? void 0 : (ref1 = homePage.data) === null || ref1 === void 0 ? void 0 : ref1.howitworks.map(function(item, index) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_HowItWorks, {
                    homePage: homePage,
                    titleVariant: "h4",
                    descVariant: "body1",
                    icon: item.image.url,
                    title: (0,CMSText/* prismicText */.yz)(item === null || item === void 0 ? void 0 : item.title1),
                    desc: (0,CMSText/* prismicText */.yz)(item === null || item === void 0 ? void 0 : item.desc)
                }, index));
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
            draggable: true,
            scrollLock: true,
            slidesToShow: 1,
            hasDots: true,
            scrollLockDelay: 100,
            duration: 1,
            children: [
                0,
                1,
                2
            ].map(function(key) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_HowItWorks, {
                    homePage: homePage,
                    titleVariant: "h4",
                    descVariant: "body1",
                    icon: '/images/placeholder.jpg',
                    title: t('texts:general:add_a_title'),
                    desc: t('texts:general:add_a_description')
                }, key));
            })
        })
    }));
};
/* harmony default export */ var HomePage_SliderHowItWork = (SliderHowItWork);

;// CONCATENATED MODULE: ./components/HomePage/HowItWorksSection.tsx









function HowItWorksSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var HowItWorksSection_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: HowItWorksSection_defineProperty({
            padding: theme.spacing(6, 0)
        }, theme.breakpoints.down('md'), {
            padding: theme.spacing(2, 0)
        }),
        align_center: {
            textAlign: 'center',
            margin: 'auto'
        },
        padding_top: {
            paddingTop: theme.spacing(4)
        },
        spacing: HowItWorksSection_defineProperty({
            padding: theme.spacing(8, 0)
        }, theme.breakpoints.down('md'), {
            padding: theme.spacing(0)
        }),
        slideSpacing: {
            padding: theme.spacing(0, 0, 6, 0)
        },
        faqItem: {
            marginBottom: theme.spacing(2)
        }
    });
});
var HowItWorksSection = function(param) {
    var homePage = param.homePage, t = param.t;
    var ref20, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var classes = HowItWorksSection_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var isSlideOnMobile = homePage === null || homePage === void 0 ? void 0 : (ref20 = homePage.data) === null || ref20 === void 0 ? void 0 : ref20.display_slider_hiw_section_on_mobile;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "section-hiw section__spacer ".concat(classes.root),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(classes.align_center),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: 'primary',
                            variant: 'h2',
                            className: "section-hiw__title ".concat(classes.padding_top),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: homePage === null || homePage === void 0 ? void 0 : (ref1 = homePage.data) === null || ref1 === void 0 ? void 0 : ref1.titlehowitworks,
                                defaultText: t('texts:homepage:titlehowitworks')
                            })
                        }),
                        ((ref3 = homePage === null || homePage === void 0 ? void 0 : (ref2 = homePage.data) === null || ref2 === void 0 ? void 0 : ref2.deschowitworks1[0]) === null || ref3 === void 0 ? void 0 : ref3.text.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body1',
                            className: "section-hiw__subtitle ".concat(classes.padding_top),
                            children: (0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref4 = homePage.data) === null || ref4 === void 0 ? void 0 : ref4.deschowitworks1)
                        }),
                        ((ref6 = homePage === null || homePage === void 0 ? void 0 : (ref5 = homePage.data) === null || ref5 === void 0 ? void 0 : ref5.deschowitworks2[0]) === null || ref6 === void 0 ? void 0 : ref6.text.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            className: "section-hiw__subtitle ".concat(classes.padding_top),
                            children: (0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref7 = homePage.data) === null || ref7 === void 0 ? void 0 : ref7.deschowitworks2)
                        }),
                        (homePage === null || homePage === void 0 ? void 0 : (ref8 = homePage.data) === null || ref8 === void 0 ? void 0 : ref8.howitworks.length) > 0 && isSlideOnMobile && isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.slideSpacing,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_SliderHowItWork, {
                                homePage: homePage,
                                t: t
                            })
                        }) : (homePage === null || homePage === void 0 ? void 0 : (ref9 = homePage.data) === null || ref9 === void 0 ? void 0 : ref9.howitworks.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            container: true,
                            className: "section-hiw__spacing ".concat(classes.spacing),
                            children: (homePage === null || homePage === void 0 ? void 0 : (ref10 = homePage.data) === null || ref10 === void 0 ? void 0 : ref10.howitworks.length) > 2 ? homePage === null || homePage === void 0 ? void 0 : (ref11 = homePage.data) === null || ref11 === void 0 ? void 0 : ref11.howitworks.map(function(item, index) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    xs: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_HowItWorks, {
                                        homePage: homePage,
                                        titleVariant: "h4",
                                        descVariant: "body1",
                                        icon: item.image.url,
                                        title: (0,CMSText/* prismicText */.yz)(item === null || item === void 0 ? void 0 : item.title1),
                                        desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            data: item.desc
                                        })
                                    })
                                }, index));
                            }) : [
                                0,
                                1,
                                2
                            ].map(function(key) {
                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                    item: true,
                                    sm: 12,
                                    lg: 4,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_HowItWorks, {
                                        homePage: homePage,
                                        titleVariant: "h4",
                                        descVariant: "body1",
                                        icon: '/images/placeholder.jpg',
                                        title: t('texts:general:add_a_title'),
                                        desc: t('texts:general:add_a_description')
                                    })
                                }, key));
                            })
                        }),
                        (0,CMSText/* isPrismicText */.LT)(homePage === null || homePage === void 0 ? void 0 : (ref12 = homePage.data) === null || ref12 === void 0 ? void 0 : ref12.cta_how_it_works) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: (homePage === null || homePage === void 0 ? void 0 : (ref13 = homePage.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.cta_hiw_link) === null || ref14 === void 0 ? void 0 : ref14.url) || '/shop',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: 'contained',
                                    color: 'primary',
                                    className: 'section-hiw__cta',
                                    onClick: function() {
                                        var ref, ref16, ref17, ref18, ref19;
                                        return trackEvent({
                                            category: 'HomePage',
                                            href: (homePage === null || homePage === void 0 ? void 0 : (ref = homePage.data) === null || ref === void 0 ? void 0 : (ref16 = ref.cta_hiw_link) === null || ref16 === void 0 ? void 0 : ref16.url) || '/shop',
                                            action: "CTA click ".concat((0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref17 = homePage.data) === null || ref17 === void 0 ? void 0 : ref17.cta_how_it_works)),
                                            name: "from How it works section to ".concat((homePage === null || homePage === void 0 ? void 0 : (ref18 = homePage.data) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.cta_hiw_link) === null || ref19 === void 0 ? void 0 : ref19.url) || '/shop')
                                        });
                                    },
                                    children: (0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref15 = homePage.data) === null || ref15 === void 0 ? void 0 : ref15.cta_how_it_works)
                                })
                            })
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var HomePage_HowItWorksSection = (HowItWorksSection);


/***/ })

}]);